<template>
  <div class="search-page">
    <ProductsListingContainer
      entity-type="search"
      :param-top-category="paramTopCategory"
      :param-category="paramCategory"
      :param-sub-category="paramSubCategory"
    />
  </div>
</template>

<script>
import ProductsListingContainer from '../../components/ProductsListingContainer.vue'
import i18n from '../../mixins/i18n'
import searchQueryIdCookieHelper from '../../mixins/searchQueryIdCookieHelper'
import productFiltersHelper from '../../mixins/productFiltersHelper'

const brandsToRedirect = ['hermes']
const countriesToRedirect = ['SG', 'ID', 'HK']

export default {
  name: 'Index',

  components: {
    ProductsListingContainer
  },

  mixins: [i18n, productFiltersHelper, searchQueryIdCookieHelper],

  beforeRouteLeave(to, from, next) {
    this.$store.commit('listingPageSearch/setQuery', '')
    next()
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const queryParam = vm.routeQuery(to)

      if (vm.isValidBrandToRedirect(vm.$i18n.countryCode, queryParam)) {
        vm.brandRedirect(queryParam, false)
      }
    })
  },

  beforeRouteUpdate(to, from, next) {
    const queryParam = this.routeQuery(to)

    if (this.isValidBrandToRedirect(this.$i18n.countryCode, queryParam)) {
      this.brandRedirect(queryParam, true)
    } else {
      next()
    }
  },

  data() {
    return {
      paramTopCategory: '',
      paramCategory: '',
      paramSubCategory: ''
    }
  },

  fetch() {
    this.paramTopCategory = this.$route.params?.topCategory || ''
    this.paramCategory = this.$route.params?.category || ''
    this.paramSubCategory = this.$route.params?.subCategory || ''
  },

  head() {
    return {
      title: `${this.$t('dictionary.search')} | ${this.$t(
        'layout.seoMeta.title'
      )}`
    }
  },

  methods: {
    brandRedirect(queryParam, redirectWithHistory) {
      if (redirectWithHistory) {
        this.$router.push(`/brands/${queryParam}`)
      } else {
        this.$router.replace(`/brands/${queryParam}`)
      }
    },

    routeQuery(to) {
      return this.normalizeAccentedProductName(`${to.query.q}`.toLowerCase())
    },

    isValidBrandToRedirect(countryCode, queryParam) {
      return (
        brandsToRedirect.includes(queryParam) &&
        countriesToRedirect.includes(countryCode)
      )
    }
  }
}
</script>
